<mat-form-field appearance="outline">
  <mat-label>Month</mat-label>
  <mat-select [(value)]="currentMonthId" (selectionChange)="changeCurrentMonth($event)">
    @for (m of months; track m) {
      <mat-option [value]="m.id">
        {{ m.title }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
